export default __webpack_public_path__ + "static/media/contact-2.3521dcc9.gif";